<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FBMHD">Contents</h1>
<h2 class="TOC-FBMHD"><a href="#/int"><strong>Introduction</strong></a></h2>
<h2 class="TOC-FBMHD"><a href="#/c01"><strong>Equipment</strong></a></h2>
<p class="TOC-AHD"><a href="#/c01#s1">Ingredients</a></p>
<p class="TOC-AHD"><a href="#/c01#s2">Techniques</a></p>
<p class="TOC-AHD"><a href="#/c01#s3">Troubleshooting</a></p>
<h2 class="TOCCT"><span href="#/c02" title="Link target outside of Sample">Brilliant Basics</span></h2>
<p class="TOC-AHD"><span href="#/c02#s4" title="Link target outside of Sample">Basic White loaf</span></p>
<p class="TOC-AHD"><span href="#/c02#s5" title="Link target outside of Sample">Quick White Rolls</span></p>
<p class="TOC-AHD"><span href="#/c02#s6" title="Link target outside of Sample">Tea Cakes</span></p>
<p class="TOC-AHD"><span href="#/c02#s7" title="Link target outside of Sample">BBQ Twist &amp; Swirl Loaf</span></p>
<p class="TOC-AHD"><span href="#/c02#s8" title="Link target outside of Sample">Cinnamon Twist &amp; Swirl Loaf</span></p>
<p class="TOC-AHD"><span href="#/c02#s9" title="Link target outside of Sample">Malthouse Loaf</span></p>
<p class="TOC-AHD"><span href="#/c02#s10" title="Link target outside of Sample">Honey Oat Rolls</span></p>
<p class="TOC-AHD"><span href="#/c02#s11" title="Link target outside of Sample">Bacon &amp; Cheese Potato Bread</span></p>
<p class="TOC-AHD"><span href="#/c02#s12" title="Link target outside of Sample">Chorizo &amp; Chilli Potato Bread</span></p>
<p class="TOC-AHD"><span href="#/c02#s13" title="Link target outside of Sample">Spiced Chocolate Orange Fingers</span></p>
<p class="TOC-AHD"><span href="#/c02#s14" title="Link target outside of Sample">Iced Lemon Fingers</span></p>
<h2 class="TOCCT"><span href="#/c03" title="Link target outside of Sample">Perfect Pre-Ferment</span></h2>
<p class="TOC-AHD"><span href="#/c03#s15" title="Link target outside of Sample">Crusty Cobb</span></p>
<p class="TOC-AHD"><span href="#/c03#s16" title="Link target outside of Sample">Tiger Bread</span></p>
<p class="TOC-AHD"><span href="#/c03#s17" title="Link target outside of Sample">Seeded Multigrain Loaf</span></p>
<p class="TOC-AHD"><span href="#/c03#s18" title="Link target outside of Sample">Maple &amp; Pecan Loaf</span></p>
<p class="TOC-AHD"><span href="#/c03#s19" title="Link target outside of Sample">Danish Apple Plait</span></p>
<p class="TOC-AHD"><span href="#/c03#s20" title="Link target outside of Sample">Picnic Plait</span></p>
<p class="TOC-AHD"><span href="#/c03#s21" title="Link target outside of Sample">Ciabatta with Olive Oil</span></p>
<p class="TOC-AHD"><span href="#/c03#s22" title="Link target outside of Sample">Rosemary &amp; Sea Salt Foccacia</span></p>
<p class="TOC-AHD"><span href="#/c03#s23" title="Link target outside of Sample">Stilton &amp; Cranberry Wheel</span></p>
<p class="TOC-AHD"><span href="#/c03#s24" title="Link target outside of Sample">Chocolate &amp; Hazelnut Wheel</span></p>
<h2 class="TOCCT"><span href="#/c04" title="Link target outside of Sample">Further Favourites</span></h2>
<p class="TOC-AHD"><span href="#/c04#s25" title="Link target outside of Sample">Bagels</span></p>
<p class="TOC-AHD"><span href="#/c04#s26" title="Link target outside of Sample">Sweet Cinnamon &amp; Cranberry Bagels</span></p>
<p class="TOC-AHD"><span href="#/c04#s27" title="Link target outside of Sample">Challah</span></p>
<p class="TOC-AHD"><span href="#/c04#s28" title="Link target outside of Sample">Herby Braided Loaf</span></p>
<p class="TOC-AHD"><span href="#/c04#s29" title="Link target outside of Sample">Brioche</span></p>
<p class="TOC-AHD"><span href="#/c04#s30" title="Link target outside of Sample">Brioche Pizza</span></p>
<p class="TOC-AHD"><span href="#/c04#s31" title="Link target outside of Sample">Danish Pastry – Raisin Whirls</span></p>
<p class="TOC-AHD"><span href="#/c04#s32" title="Link target outside of Sample">Croissants</span></p>
<h2 class="TOC-FBMHD"><span href="#/sup" title="Link target outside of Sample"><strong>Suppliers</strong></span></h2>
<h2 class="TOC-FBMHD"><span href="#/ata" title="Link target outside of Sample"><strong>About the Author &amp; Acknowledgments</strong></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1437d7ae